<template>
	<span v-if="data" v-show="data.name" class="c-state" :tag="tag" :style="compStyle">{{data.name}}</span>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'cState',
		
		props: {
			dict: String,
			async: Boolean,
			value: [Number, String],
			tag: Boolean
		},
		
		data() {
			return {
				color: {
					gray: '#999999',
					blue: '#0D6EFE',
					red: '#FF0000',
					green: '#2EBC78',
					yellow: '#FFAE00',
					orange: '#FF5400'
				}
			}
		},
		
		computed: {
			...mapState(['dictData', 'asyncDictData']),
			
			compDictData() {
				if (this.async) {
					return this.asyncDictData[`${this.dict}Data`];
				} else {
					return this.dictData[`${this.dict}Data`];
				}
			},
			
			data() {
				return this.compDictData ? this.compDictData[this.value] : {name: this.value};
			},

			compStyle() {
				let color = this.color[this.data.color] || this.data.color;
				return this.tag ? {
					color: color,
					background: this.hex2Rgb(color, 0.1)
				} : {
					color: color
				}
			}
		},
		
		created() {
			if (this.async && this.dict && !this.compDictData) {
				this.$store.dispatch('getAsyncDict', this.dict);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-state {
		line-height: normal;

		&[tag] {
			padding: 2px 5px;
			border-radius: 4px;
		}	
	}
</style>